import React from 'react'

function SettingIntergration() {
  return (
    <div className="setting-block">SettingIntergration</div>
  )
}

export default SettingIntergration